import { Book, Nullable, Profile, Project, ProjectUtils, Tag } from "@brg/api";
import { ProfileRole, bProfile } from "@brg/auth";
import {PaymentStatus} from "../pages/BookEdit/BookEdit";
import {IProjectLight} from "../../../shared/common";
import { HsePolicies } from "shared/constants/HsePolicies";


export class BookDelegate {
    public static canView(user: Nullable<Profile>, book: Nullable<Book | Book<'Global'>>) {
        if (!book)
            return false;

        if (book.status === 1)
            return true;

        if (book.status === 6)
            return true;

        if (!user)
            return false;

        if (bProfile.isModer(user))
            return true;

        if (bProfile.isMiddleModer(user))
            return true;

        if (book.creatorId === user.accountId)
            return true;

        if (book.authorId === user.accountId)
            return true;

        if (book.coAuthorIds?.includes(user.accountId))
            return true;

        if (book.curatorIds?.includes(user.accountId))
            return true;

        const canViewBook = user.rolesList && Array.isArray(user.rolesList)
            && (new ProfileRole(HsePolicies.view_book)).containsIn(user.rolesList);

        if (canViewBook)
            return true;
        
        return false;
    }
    
    public static canEdit(user: Nullable<Profile>, book: Nullable<Book | Book<'Global'>>, ) {
        if (!user || !book)
            return false;

        if (bProfile.isModer(user))
            return true;

        if (bProfile.isMiddleModer(user))
            return true;

        if (book.creatorId === user.accountId)
            return true;

        if (book.authorId === user.accountId)
            return true;

        if (book.coAuthorIds?.includes(user.accountId))
            return true;

        if (book.curatorIds?.includes(user.accountId))
            return true;

        const canEditBook = user.rolesList && Array.isArray(user.rolesList)
            && (new ProfileRole(HsePolicies.edit_book)).containsIn(user.rolesList);

        if (canEditBook)
            return true;
        
        return false;
    }

    public static canChangePaymentType(book: Nullable<Book | Book<'Global'>>) {
        if (book?.status === 1)
            return false;

        return true;
    }

    public static isPaid(book: Nullable<Book | Book<'Global'> | Project | Project<'Global'> | IProjectLight>): boolean {
        // @ts-ignore
        return Boolean(([1,9].includes(book?.status || 0) && book?.paymentType === PaymentStatus.PayBook) || (book?.book?.status === 1 && book?.book?.paymentType === PaymentStatus.PayBook))
    }

    public static canPublish(user: Nullable<Profile>, book: Nullable<Book | Book<'Global'>>, title: string, tags: Tag[], chapters: Project[], chapterLongreadsPostCount: number[]) {
        if (!user || !book)
            return false;

        if (title.replaceAll(" ", "").length === 0) return false

        if (tags.length === 0) return false

        if (!tags.find((tag) => tag.isEducationTag)) return false

        if (chapters.length === 0) return false

        let hasUncompletedChapter = false
        
        chapters.forEach((chapter, idx) => {
            if (chapter.title.length === 0 || !ProjectUtils.getTitleImageOrUndefined(chapter) || chapter.tagsID.length === 0 || chapterLongreadsPostCount[idx] === 0) {
                hasUncompletedChapter = true
            }
        })

        if (hasUncompletedChapter) return false

        if ([0,1,10]?.includes(book.status)) {
            if (BookDelegate.canEdit(user, book))
                return true;
        }

        return false;
    }

    public static canDelete(user: Nullable<Profile>, book: Nullable<Book | Book<'Global'>>) {
        return false;
    }

    public static canBeDraft(user: Nullable<Profile>, book: Nullable<Book | Book<'Global'>>) {
        if (!user || !book)
            return false;

        if (bProfile.isModer(user))
            return true;

        if (bProfile.isMiddleModer(user))
            return true;

        if (book.creatorId === user.accountId)
            return true;

        if (book.authorId === user.accountId)
            return true;

        if (book.coAuthorIds?.includes(user.accountId))
            return true;

        if (book.curatorIds?.includes(user.accountId))
            return true;

        const canBeDraft = user.rolesList && Array.isArray(user.rolesList)
            && (new ProfileRole(HsePolicies.move_to_draft_book)).containsIn(user.rolesList);

        if (canBeDraft)
            return true;
        
        return false;
    }

    public static canModerate(user: Nullable<Profile>, book: Nullable<Book | Book<'Global'>>) {
        return false;
    }

    public static isSelfCurate(user: Nullable<Profile>, book: Nullable<Book | Book<'Global'>>) {
        if (!user || !book)
            return false;

        if (book.curatorIds.includes(user.accountId))
            return true;

        return false;
    }

    public static canCurate(user: Nullable<Profile>, book: Nullable<Book | Book<'Global'>>) {
        if (!user || !book)
            return false;

        if (bProfile.isModer(user))
            return true;

        if (bProfile.isEmployee(user))
            return true;
        
        const canBeDraft = user.rolesList && Array.isArray(user.rolesList)
            && (new ProfileRole(HsePolicies.can_supervise_book)).containsIn(user.rolesList);

        if (canBeDraft)
            return true;

        return false;
    }

    public static showBookTools(user: Nullable<Profile>, book: Nullable<Book | Book<'Global'>>) {
        return BookDelegate.canCurate(user, book);
    }
}
import { Book, Nullable, Profile, Project, ProjectUtils, Tag } from "@brg/api";
import { ProfileRole, bProfile } from "@brg/auth";
import {PaymentStatus} from "../pages/BookEdit/BookEdit";
import {IProjectLight} from "../../../shared/common";
import { HsePolicies } from "shared/constants/HsePolicies";


export class BookDelegate {
    public static canView(user: Nullable<Profile>, book: Nullable<Book | Book<'Global'>>) {
        if (!book)
            return false;

        if (book.status === 1)
            return true;

        if (book.status === 6)
            return true;

        if (!user)
            return false;

        if (bProfile.isModer(user))
            return true;

        if (bProfile.isMiddleModer(user))
            return true;

        if (book.creatorId === user.accountId)
            return true;

        if (book.authorId === user.accountId)
            return true;

        if (book.coAuthorIds?.includes(user.accountId))
            return true;

        if (book.curatorIds?.includes(user.accountId))
            return true;

        const canViewBook = user.rolesList && Array.isArray(user.rolesList)
            && (new ProfileRole(HsePolicies.view_book)).containsIn(user.rolesList);

        if (canViewBook)
            return true;
        
        return false;
    }
    
    public static canEdit(user: Nullable<Profile>, book: Nullable<Book | Book<'Global'>>, ) {
        if (!user || !book)
            return false;

        if (bProfile.isModer(user))
            return true;

        if (bProfile.isMiddleModer(user))
            return true;

        if (book.creatorId === user.accountId)
            return true;

        if (book.authorId === user.accountId)
            return true;

        if (book.coAuthorIds?.includes(user.accountId))
            return true;

        if (book.curatorIds?.includes(user.accountId))
            return true;

        const canEditBook = user.rolesList && Array.isArray(user.rolesList)
            && (new ProfileRole(HsePolicies.edit_book)).containsIn(user.rolesList);

        if (canEditBook)
            return true;
        
        return false;
    }

    public static canChangePaymentType(book: Nullable<Book | Book<'Global'>>) {
        if (book?.status === 1)
            return false;

        return true;
    }

    public static isPaid(book: Nullable<Book | Book<'Global'> | Project | Project<'Global'> | IProjectLight>): boolean {
        // @ts-ignore
        return Boolean(([1,9].includes(book?.status || 0) && book?.paymentType === PaymentStatus.PayBook) || (book?.book?.status === 1 && book?.book?.paymentType === PaymentStatus.PayBook))
    }

    public static canPublish(user: Nullable<Profile>, book: Nullable<Book | Book<'Global'>>, title: string, tags: Tag[], chapters: Project[], chapterLongreadsPostCount: number[]) {
        if (!user || !book)
            return false;

        if (title.replaceAll(" ", "").length === 0) return false

        if (tags.length === 0) return false

        if (!tags.find((tag) => tag.isEducationTag)) return false

        if (chapters.length === 0) return false

        let hasUncompletedChapter = false
        
        chapters.forEach((chapter, idx) => {
            if (chapter.title.length === 0 || !ProjectUtils.getTitleImageOrUndefined(chapter) || chapter.tagsID.length === 0 || chapterLongreadsPostCount[idx] === 0) {
                hasUncompletedChapter = true
            }
        })

        if (hasUncompletedChapter) return false

        if ([0,1,10]?.includes(book.status)) {
            if (BookDelegate.canEdit(user, book))
                return true;
        }

        return false;
    }

    public static canDelete(user: Nullable<Profile>, book: Nullable<Book | Book<'Global'>>) {
        return false;
    }

    public static canBeDraft(user: Nullable<Profile>, book: Nullable<Book | Book<'Global'>>) {
        if (!user || !book)
            return false;

        if (bProfile.isModer(user))
            return true;

        if (bProfile.isMiddleModer(user))
            return true;

        if (book.creatorId === user.accountId)
            return true;

        if (book.authorId === user.accountId)
            return true;

        if (book.coAuthorIds?.includes(user.accountId))
            return true;

        if (book.curatorIds?.includes(user.accountId))
            return true;

        const canBeDraft = user.rolesList && Array.isArray(user.rolesList)
            && (new ProfileRole(HsePolicies.move_to_draft_book)).containsIn(user.rolesList);

        if (canBeDraft)
            return true;
        
        return false;
    }

    public static canModerate(user: Nullable<Profile>, book: Nullable<Book | Book<'Global'>>) {
        return false;
    }

    public static isSelfCurate(user: Nullable<Profile>, book: Nullable<Book | Book<'Global'>>) {
        if (!user || !book)
            return false;

        if (book.curatorIds.includes(user.accountId))
            return true;

        return false;
    }

    public static canCurate(user: Nullable<Profile>, book: Nullable<Book | Book<'Global'>>) {
        if (!user || !book)
            return false;

        if (bProfile.isModer(user))
            return true;

        if (bProfile.isEmployee(user))
            return true;
        
        const canBeDraft = user.rolesList && Array.isArray(user.rolesList)
            && (new ProfileRole(HsePolicies.can_supervise_book)).containsIn(user.rolesList);

        if (canBeDraft)
            return true;

        return false;
    }

    public static showBookTools(user: Nullable<Profile>, book: Nullable<Book | Book<'Global'>>) {
        return BookDelegate.canCurate(user, book);
    }
}
